const defaultState = () => ({
  levels: [],
  faqs: [],
  readinessState: null,
});

const getters = {
  levels: state => state.levels,
  faqs: state => state.faqs,
  readinessState: state => state.readinessState,
};

const mutations = {
  setLevels(state, levels) {
    state.levels = levels;
  },
  setFaqs(state, faqs) {
    state.faqs = faqs;
  },
  setReadinessState(state, data) {
    state.readinessState = data;
  },
  reset(state) {
    state.readinessState = null;
  },
};

const actions = {
  fetchReadinessState({ commit, rootGetters }) {
    return rootGetters['session/ajax'].get('/pop_readiness_states').then(response => {
      commit('setReadinessState', response.data.records?.[0] || null);
      return response;
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
